import { t as uiText } from '../../i18n';
import React from 'react';
import './Day0Panel.css';

interface EmbedSecurityPanelProps {
  origins: string[];
  siteUrl: string;
  saving: boolean;
  removing: boolean;
  onSiteUrlChange: (siteUrl: string) => void;
  onSubmit: (siteUrl: string) => void;
  onRemove: (origin: string) => void;
  onClose: () => void;
}

const EmbedSecurityPanel: React.FC<EmbedSecurityPanelProps> = ({
  origins,
  siteUrl,
  saving,
  removing,
  onSiteUrlChange,
  onSubmit,
  onRemove,
  onClose,
}) => {
  const ready = origins.length > 0;
  const busy = saving || removing;

  return (
    <section className="day0-panel">
      <header className="day0-panel__header">
        <h2 className="day0-panel__title">{uiText("Register a host site")}</h2>
        <button type="button" className="day0-panel__close" onClick={onClose} aria-label={uiText("Close")}>
          ×
        </button>
      </header>
      <p className="day0-panel__lead">
        {uiText("You can register multiple host sites. Register the URL of the site where you will place the widget, and a token for that site will be issued. The widget cannot be used on sites that are not registered, which also prevents others from using it without permission.")}
      </p>

      {ready && (
        <ul className="day0-panel__origins">
          {origins.map((origin) => (
            <li key={origin} className="day0-panel__origin">
              <span className="day0-panel__origin-text" title={origin}>{origin}</span>
              <button
                type="button"
                className="day0-panel__origin-remove"
                onClick={() => onRemove(origin)}
                disabled={busy}
                aria-label={`${uiText("Remove this URL")}: ${origin}`}
              >
                {uiText("Delete")}
              </button>
            </li>
          ))}
        </ul>
      )}

      <label className="day0-panel__label">
        {uiText("Add a host site URL")}
        <input
          type="url"
          value={siteUrl}
          onChange={(e) => onSiteUrlChange(e.target.value)}
          placeholder="https://example.com"
          disabled={busy}
        />
      </label>
      <button
        type="button"
        className="day0-panel__save"
        onClick={() => onSubmit(siteUrl)}
        disabled={busy || !siteUrl.trim()}
      >
        {saving ? uiText("Issuing…") : ready ? uiText("Allow this site too") : uiText("Issue token")}
      </button>
    </section>
  );
};

export default EmbedSecurityPanel;
